import React from "react";
import { Image } from "react-bootstrap";
import QualityCheckQuestion from "../QualityCheckQuestion";
import initialQuestions from "./questions.js";
import exampleJuiceFront from "./images/exampleJuiceFront.png";

export default class QualityCheck extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      questions: initialQuestions,
      currentClipArea: initialQuestions[0].clipArea,
      exampleImageUrl: exampleJuiceFront,
    };

    this.handleQuestionHover = this.handleQuestionHover.bind(this);
  }

  setQuestionActive(question) {
    this.setState({
      currentClipArea: question.clipArea,
      exampleImageUrl: question.image,
    });
  }

  handleQuestionHover(id) {
    const { questions } = this.state;
    const activeQuestion = questions.find(question => question.id === id);
    this.setQuestionActive(activeQuestion);

    this.setState({ questions });
  }

  render() {
    return (
      <div className="container content-margin">
        <div className="row">
          <div className="col-md-3 hidden-xs hidden-sm">
            <div className="exampleImageContainer">
              <Image
                className="exampleImage"
                src={this.state.exampleImageUrl}
              />
              <Image
                className="exampleImageHiglightArea"
                src={this.state.exampleImageUrl}
                style={{ clip: `rect(${this.state.currentClipArea})` }}
              />
            </div>
          </div>
          <div className="col-md-7 col-xs-12 col-sm-12">
            <h1>
              <nobr>Rahmenbedingungen</nobr> für das Produkt
            </h1>
            <p>
              An alles gedacht? Bevor Dein Produkt auf EDEKA StartHub vorgestellt
              werden kann, wollen wir gemeinsam mit Dir einige Fragen
              durchgehen.
            </p>

            {this.state.questions.map((question, index) => (
              <QualityCheckQuestion
                key={index}
                question={question}
                onMouseOver={this.handleQuestionHover}
                onFocus={this.handleQuestionHover}
              />
            ))}
          </div>
        </div>
      </div>
    );
  }
}
